import { Col, Row, Td, Tr } from "@visa/vds";
import React, { useContext, useEffect, useState } from "react";
import MCSPagedTable from "components/MCSPagedTable";
import { GlobalAlertContext } from "context/GlobalAlertContext";
import { useAuthContextUser } from "context/AuthContext";
import { PACKAGE_LIST_EXTERNAL_TABLE_HEADERS } from "_constants/PackageListConstants";
import { trackPromise } from "react-promise-tracker";
import { certificationPackageListService } from "services/certification.packageList";
import ErrorPage from "pages/Error/ErrorPage";
import CertificationPackagesTableAction from "pages/Dashboard/Components/ProductCertification/CertificationPackagesTableAction";
import { DateHelper } from "_helpers/DateHelper";
import { FileHelper } from "_helpers/FileHelper";
import { ceritificationPackageService } from "services/certification.certificationPackage";
import CertificationPackageState from "pages/CertificationWorkflow/SharedComponents/CertificationPackageState";

const ExternalCertificationPackagesList = ({selectedBid}) => {
    let [open, setOpen] = useState(false)

    const alertContext = useContext(GlobalAlertContext);
    const user = useAuthContextUser();

    const [sortBy, setSortBy] = useState("lastUpdatedOn");
    const [totalCount, setTotalCount] = useState(0);
    const [selectedPage, setSelectedPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [desc, setDesc] = useState(true);
    const PAGE_SIZE = 10;
    const tableHeaders = PACKAGE_LIST_EXTERNAL_TABLE_HEADERS;
    const [error, setPageError] = useState(null);
    
    const [certificationPackages, setCertificationPackages] = useState(null);

    const setComponentState = (result) => {
        setCertificationPackages(result.data.result.items)
        setTotalCount(result.data.result.totalCount)
        setTotalPage(Math.ceil(result.data.result.totalCount / PAGE_SIZE))
    }

    const fetchData = (selectedPage, sortBy, desc) => {
        let skipCount = (selectedPage - 1) * PAGE_SIZE;
        trackPromise(
            certificationPackageListService.ExternalGetAllPackages(skipCount, sortBy, desc)
                .then((result) => {
                    setComponentState(result)
                })
                .catch(error => {
                    setPageError(error);
                    alertContext.setGlobalErrorMessage(error.message);
                })
        );
    }

    const handlePageChange = (newPage) => {
        setSelectedPage(newPage)
        fetchData(newPage, sortBy, desc);
    }

    const handleSortChange = async (sortBy = null, desc = false) => {
        fetchData(selectedPage, sortBy, desc);
    }

    const downloadComplianceLetter = (compApprovalId, packageId) => {
        trackPromise(
            ceritificationPackageService.DownloadComplianceLetter(user.organization.bid, compApprovalId, packageId)
                .then((result) => {
                    FileHelper.DownloadFile(result);
                })
                .catch(error => alertContext.setErrorMessage("Unable to download Compliance Letter. Please try again later."))
        );
    }

    useEffect(() => {
        fetchData(selectedPage, sortBy, desc)
    }, [selectedBid])

    if (error) return <ErrorPage/>

    return (
        <>
            <Row>
                <Col>
                    <Row className="approved-products-table">
                        <MCSPagedTable
                            size={"compact"}
                            colHeaders={tableHeaders}
                            useSearchBar={false}
                            usePagination={true}
                            selectedPage={selectedPage}
                            setSelectedPage={handlePageChange}
                            totalPages={totalPage}
                            ordered={sortBy}
                            setOrdered={setSortBy}
                            sortData={handleSortChange}
                            isDsc={desc}
                            setDsc={setDesc}
                            pageSize={PAGE_SIZE}
                            totalCount={totalCount}
                            tableData={
                                certificationPackages && certificationPackages.map((row, key) => {
                                    return (
                                        <Tr className="row-vstt-even" key={key}>
                                            <Td id={"packageId_" + key}>{row.id}</Td>
                                            <Td id={"packageName_" + key}>{row.packageName}</Td>
                                            <Td id={"implementationType_" + key}>{row.implementationType}</Td>
                                            <Td id={"packageCreatedOn_" + key}>{DateHelper.ToFormattedDate(row.createdOn)}</Td>
                                            <Td id={"packageUpdatedOn_" + key}>{DateHelper.ToFormattedDate(row.lastUpdatedOn)}</Td>
                                            <Td id={"certificationComplianceLetter_" + key}>
                                                <a download 
                                                    style={{ "cursor": "pointer" }}
                                                    onClick={() => downloadComplianceLetter(row.compApprovalId, row.id)}>
                                                    {row.compApprovalId}
                                                </a>
                                            </Td>
                                            <Td id={"packageState_" + key} style={{ "display": "flex", "paddingTop": "12px", "flexDirection": "column", "justifyContent": "center" }}>
                                                <CertificationPackageState
                                                    packageState={row.packageState}
                                                    packageStateDisplayName={row.packageStateDisplayName}
                                                />
                                            </Td>
                                            <Td id={"packageAction_" + key}>
                                                <CertificationPackagesTableAction
                                                    packageState={row.packageState}
                                                    user={user}
                                                    packageId={row.id}
                                                />
                                            </Td>
                                        </Tr>
                                    )
                                })
                            }
                        />
                    </Row>
                </Col>
            </Row>
        </>
    );
}

export default ExternalCertificationPackagesList